export default __webpack_public_path__ + "static/media/itc.427c6cdd.png";